import { gql } from "apollo-angular";

export default gql`
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $filter: RegisteredCountriesFilterInput
  ) {
    createCompany(input: $input) {
      id
      name
      account {
        id
        name
      }
      vatNumber
      countryCode
      createdAt
      contacts {
        name
        email
        phone
        mobile
        linkedIn
      }
      registeredCountries(filter: $filter) {
        objects {
          countryCode
          registrationPeriod {
            from
            to
          }
        }
      }
      address {
        addressType
        addressLine1
        addressLine2
        extraInformation
        streetName
        streetNumber
        city
        region
        postalCode
        countryCode
      }
      partialExemptionType
      bankDetails {
        name
        accountNumber
        ibanNumber
        bankNumber
        sortCode
      }
      vatPortals {
        type
        id
      }
      enabledProducts
      companySourceEntity
      type
      status
      inactiveReason
      inactiveDescription
    }
  }
`;
